import { useMemo } from 'react'
import { useUser } from 'modules/user'

import { useStrapiWSTOData } from 'modules/brands'

import type { UserGender } from 'typings/graphql'
import type { ComponentWebsiteTakeoverFeaturedBrandModal } from 'typings/strapi.graphql'


const ALL_GENDERS = [ 'FEMALE' as const, 'MALE' as const ]

const modifyStrapiData = (userGender: UserGender, data): BrandsModule.StrapiWSTOModalWithProductsOptions => {
  const modalData = data?.mainPage?.find(({ __typename, gender }) => {
    if (__typename !== 'ComponentWebsiteTakeoverFeaturedBrandModal') {
      return
    }
    return gender === userGender || gender === 'ALL'
  }) as ComponentWebsiteTakeoverFeaturedBrandModal

  const availableGenders = !modalData?.gender || modalData.gender === 'ALL' ? ALL_GENDERS : [ modalData.gender ]

  return { genders: availableGenders }
}

const useStrapiWSTOModalWithProductsOptions = (): BrandsModule.StrapiWSTOModalWithProductsOptions => {
  const { gender } = useUser()

  const { data, isFetching } = useStrapiWSTOData()

  const strapiData = useMemo(() => {
    return data ? modifyStrapiData(gender, data) : null
  }, [ gender, data ])

  if (isFetching) {
    return null
  }

  return strapiData
}

export default useStrapiWSTOModalWithProductsOptions
